// eslint-disable-next-line no-use-before-define
const React = require('react');
const PropTypes = require('prop-types');

const Loading = ({
  children, style, randomTexts, fullScreen, error, onRetry,
}) => {
  const [hungryId] = React.useState(() => (new Date().getMinutes() % 7) + 1);
  const [currentText, setCurrentText] = React.useState('');

  React.useEffect(() => {
    setCurrentText('');
    if (error || !randomTexts.length) return undefined;
    const updateText = () => {
      setCurrentText(randomTexts[Math.floor(Math.random() * randomTexts.length)]);
    };
    updateText();
    const handle = setInterval(updateText, 10000);
    return () => clearInterval(handle);
  }, [randomTexts, error]);

  return (
    <div className={`component-loading${fullScreen ? ' component-loading--fullscreen' : ''}`} style={style}>
      <div className="component-loading__content">
        {!error && (
          <div className="component-loading__animation" aria-hidden="true">
            <div className={`hungry-${hungryId}`} />
          </div>
        )}
        <div role={error ? 'alert' : 'status'} aria-live={error ? 'assertive' : 'polite'} aria-atomic="true">
          {children || 'Loading...'}
        </div>
        {!error && currentText && <p className="component-loading__hint">{currentText}</p>}
        {onRetry && <button type="button" className="btn btn-primary" onClick={onRetry}>Try again</button>}
      </div>
    </div>
  );
};

Loading.propTypes = {
  children: PropTypes.node,
  style: PropTypes.shape({}),
  randomTexts: PropTypes.arrayOf(PropTypes.string),
  fullScreen: PropTypes.bool,
  error: PropTypes.bool,
  onRetry: PropTypes.func,
};
Loading.defaultProps = {
  children: 'Loading...',
  style: {},
  randomTexts: [],
  fullScreen: false,
  error: false,
  onRetry: undefined,
};

module.exports = Loading;
